
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round","d":"M11.5 14.5v-5h-6v5m0-12v3H10m3.167 9H3.833A1.334 1.334 0 0 1 2.5 13.167V3.833A1.333 1.333 0 0 1 3.833 2.5H10.5l4 4v6.667a1.334 1.334 0 0 1-1.333 1.333"}})])
          )
        }
      }
    